"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var GoToPage = function GoToPage(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-480.000000, -166.000000)",
    fillRule: "nonzero",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(480.000000, 166.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.6326114,0 L3.36738864,0 C1.51205558,0 0,1.51205558 0,3.37556191 L0,10 C0,10.404577 0.331017573,10.7355946 0.735594606,10.7355946 L12.0433183,10.7355946 L10.4209236,12.3579894 C10.134859,12.6440539 10.134859,13.1099305 10.4209236,13.4000817 C10.5639559,13.543114 10.7519412,13.6166735 10.9399264,13.6166735 C11.1279117,13.6166735 11.315897,13.543114 11.4589293,13.4000817 L14.3359215,10.5230895 C14.6219861,10.2370249 14.6219861,9.77114834 14.3359215,9.48099714 L11.4589293,6.6040049 C11.1728647,6.31794034 10.7069881,6.31794034 10.4168369,6.6040049 C10.1307724,6.89006947 10.1307724,7.35594606 10.4168369,7.64609726 L12.0433183,9.26440539 L1.47118921,9.26440539 L1.47118921,3.37556191 C1.47118921,2.32529628 2.32120964,1.47118921 3.36738864,1.47118921 L16.6326114,1.47118921 C17.6787904,1.47118921 18.5288108,2.32529628 18.5288108,3.37556191 L18.5288108,16.6244381 C18.5288108,17.6747037 17.6787904,18.5288108 16.6326114,18.5288108 L3.36738864,18.5288108 C2.32120964,18.5288108 1.47118921,17.6747037 1.47118921,16.6244381 L1.47118921,14.9080507 C1.47118921,14.5034736 1.14017164,14.1724561 0.735594606,14.1724561 C0.331017573,14.1724561 2.90373002e-16,14.5034736 2.90373002e-16,14.9080507 L2.90373002e-16,16.6244381 C2.90373002e-16,18.4838578 1.51205558,20 3.36738864,20 L16.6326114,20 C18.4879444,20 20,18.4879444 20,16.6244381 L20,3.37556191 C20,1.51614221 18.4879444,0 16.6326114,0 Z"
  })))));
};
/* eslint-enable */
var _default = GoToPage;
exports["default"] = _default;